import * as actions from './qua-distinct-filters.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, from } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ApiQuaMethod } from 'src/app/api/api-methods.qua';
import { Injectable, inject } from '@angular/core';
import { QuaDistinctFiltersI } from 'src/app/api/qua-distinct-filters/qua-distinct-filters.result.int';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { spxToasterActions } from '@softpak/components/spx-toaster';

@Injectable()
export class QuaDistinctFiltersEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);

    load$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(action => from(this.sharedGenericService.invoke(ApiQuaMethod.quaDistinctFilters, action.query))
            .pipe(
                map((result: QuaDistinctFiltersI) => actions.received({
                    result
                })),
                catchError((error) => {
                    console.error(error);
                    return [
                        actions.error({
                            messageText: error,
                        }),
                        spxToasterActions.createError({
                            autoClose: error.autoclose ? 5000 : undefined,
                            messageText: `${error?.title ? `${error?.title}: ` : ``} ${error.message}`,
                        }),
                    ];
                })
            )))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap(() => [
        ]))
    );
}
